<template>
  <div class="service-info">
    <div class="user uniline">
      <div class="name">{{ datalist.name }}</div>
      <div>
        <div class="corp">{{ datalist.corp }}</div>
        <!-- <div class="position">全球赢网建一组</div> -->
      </div>
    </div>
    <div class="post uniline">部门：{{ datalist.deptName }}</div>
    <div class="mobile uniline">手机：{{ datalist.mobile }}</div>
    <div class="email uniline">邮箱：{{ datalist.email }}</div>
  </div>
</template>

<script>
export default {
  props: {
    scope: Object,
    bind: String,
    tableData: [Object, Array]
  },
  data() {
    return {};
  },
  computed: {
    datalist() {
      let { scope, tableData, bind } = this;
      if (!tableData) return false;
      if (scope && tableData.paramList) {
        let data = {};
        Object.keys(tableData.paramList).forEach(key => {
          data[key] = scope.row[tableData.paramList[key]];
        });
        return data;
      } else if (tableData.dataStyle) {
        return tableData.dataStyle(scope, tableData, bind);
      } else {
        return {
          name: "-",
          corp: "-",
          deptName: "-",
          mobile: "-",
          email: "-"
        };
      }
    }
  },
  methods: {},
  components: {}
};
</script>

<style lang="scss" scoped>
.service-info {
  width: 100%;
  background-color: #fff;
  color: #606266;
  font-size: 14px;
}

.service-info div {
  margin: 2px 3px;
}

.service-info .user {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}

.service-info .user .name {
  font-size: 20px;
  font-weight: bold;
  margin-left: 0;
}
.uniline {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
